import { Step } from 'react-joyride'

import {
  IOnboardingCustomJoyrideStep,
  IOnboardingJoyrideStep,
  ONBOARDING_JOYRIDE_STEP_TYPE,
} from './onboardingJoyride.types'

/**
 * Generate Joyride Steps from IOnboardinCustomJoyrideStep steps
 * @param steps
 */
export function generateJoyrideSteps(steps: IOnboardingCustomJoyrideStep[]): IOnboardingJoyrideStep[] {
  const defaultProps: Partial<Step> = {
    disableBeacon: true,
  }

  return steps.map((step) => {
    switch (step.type) {
      case ONBOARDING_JOYRIDE_STEP_TYPE.GENERAL:
        return {
          ...defaultProps,
          ...step,
          target: '#root',
          placement: 'center',
        }
      case ONBOARDING_JOYRIDE_STEP_TYPE.TARGET:
      default:
        return {
          ...defaultProps,
          ...step,
        }
    }
  })
}
